/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "../../components/MKBox";
import MKTypography from "../../components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "../../examples/Navbars/DefaultNavbar";
import DefaultFooter from "../../examples/Footers/DefaultFooter";

// About Us page sections
import Testimonials from "./sections/Testimonials";
import ContactUs from "./sections/ContactUs";

// Routes
import routeKeys from "../../routeKeys";

// Images
import bgImage from "../../assets/images/emtay/bg-emtay.webp";
import Counters from "./sections/Counters";
import Features from "./sections/Features";

import { legalbar } from "./sections/legalbar";
import Technologies from "./sections/Technologies";
import AgenticTools from "./sections/AgenticTools";
import Manifesto from "./sections/Manifesto";

// i18n
import { useLanguage } from "../../i18n";

function EmtayPage() {
  const { t } = useLanguage();
  const isThanks = window.location.pathname == "/thanks";

  // Translate routes
  const routes = routeKeys.map((route) => ({
    ...route,
    name: t(route.key),
  }));

  return (
    <>
      <a name="top" />
      <DefaultNavbar routes={routes} transparent light />
      <MKBox
        width="100%"
        sx={{
          minHeight: { xs: "26rem", md: "22rem" },
          height: { xs: "48vh", md: "40vh" },
          maxHeight: { xs: "38rem", md: "34rem" },
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={8}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            sx={{
              mx: "auto",
              textAlign: "center",
              pt: { xs: 10, sm: 11, md: 12, lg: 0 },
            }}
          >
            <MKTypography
              variant="h2"
              color="white"
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              {t("hero.title")}
            </MKTypography>
            <MKTypography variant="body1" color="white" opacity={0.8} mt={1} mb={3}>
              {t("hero.subtitle")}
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 2,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        {isThanks ? <ContactUs isThanks={true} /> : null}
        <Counters />
        <a name="services" />
        <Features />
        <a name="agentic" />
        <AgenticTools />
        <Manifesto />
        <Technologies />
        <a name="contact" />
        {!isThanks ? <ContactUs isThanks={false} /> : null}
        <Testimonials />
      </Card>
      <MKBox pt={2} px={1} mt={0} py={0}>
        <DefaultFooter content={{ copyright: legalbar }} />
      </MKBox>
    </>
  );
}

export default EmtayPage;
